import { render } from "./ApeConstructorEquippedTraits.vue?vue&type=template&id=7474ce37"
import script from "./ApeConstructorEquippedTraits.vue?vue&type=script&lang=js"
export * from "./ApeConstructorEquippedTraits.vue?vue&type=script&lang=js"

import "./ApeConstructorEquippedTraits.vue?vue&type=style&index=0&id=7474ce37&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__